export const defaultValues = {
  PROPERTY_VALUE: 2500000,
  MONTHLY_RENT: 4500,
  INSTANT_RESULT: false,
  CURRENCY: "AED ",
  PRICE_PREFIX: true
}
